import { render, staticRenderFns } from "./X-catalog.vue?vue&type=template&id=55b6e51f&scoped=true"
import script from "./X-catalog.vue?vue&type=script&lang=js"
export * from "./X-catalog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55b6e51f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/bitnami/deploy/oscar_front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('55b6e51f')) {
      api.createRecord('55b6e51f', component.options)
    } else {
      api.reload('55b6e51f', component.options)
    }
    module.hot.accept("./X-catalog.vue?vue&type=template&id=55b6e51f&scoped=true", function () {
      api.rerender('55b6e51f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/magasin/X-catalog.vue"
export default component.exports